export const ORGANIZATION_SETTINGS = '/settings'
